import { render, staticRenderFns } from "./tableAdmin.vue?vue&type=template&id=0105b522&scoped=true"
import script from "./tableAdmin.vue?vue&type=script&lang=js"
export * from "./tableAdmin.vue?vue&type=script&lang=js"
import style0 from "./tableAdmin.vue?vue&type=style&index=0&id=0105b522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105b522",
  null
  
)

export default component.exports